"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.valuesFromMsgEvents = void 0;
const logger_1 = require("@shapeshiftoss/logger");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const logger = new logger_1.Logger({
    namespace: ['client', 'cosmos', 'utils'],
    level: process.env.LOG_LEVEL
});
const metaData = (msg, assetId) => {
    var _a, _b, _c, _d;
    if (!msg)
        return;
    switch (msg.type) {
        case 'delegate':
        case 'begin_unbonding':
            return {
                parser: 'cosmos',
                method: msg.type,
                delegator: msg.from,
                destinationValidator: msg.to,
                value: (_a = msg === null || msg === void 0 ? void 0 : msg.value) === null || _a === void 0 ? void 0 : _a.amount
            };
        case 'begin_redelegate':
            return {
                parser: 'cosmos',
                method: msg.type,
                sourceValidator: msg.from,
                delegator: msg.origin,
                destinationValidator: msg.to,
                value: (_b = msg === null || msg === void 0 ? void 0 : msg.value) === null || _b === void 0 ? void 0 : _b.amount,
                assetId
            };
        case 'withdraw_delegator_reward':
            return {
                parser: 'cosmos',
                method: msg.type,
                destinationValidator: msg.to,
                value: (_c = msg === null || msg === void 0 ? void 0 : msg.value) === null || _c === void 0 ? void 0 : _c.amount,
                assetId
            };
        case 'ibc_send':
        case 'ibc_receive':
            return {
                parser: 'cosmos',
                method: msg.type,
                ibcDestination: msg.to,
                ibcSource: msg.from,
                assetId,
                value: (_d = msg === null || msg === void 0 ? void 0 : msg.value) === null || _d === void 0 ? void 0 : _d.amount
            };
        // known message types with no applicable metadata
        case 'send':
            return;
        default:
            logger.warn(`unsupported message type: ${msg.type}`);
            return;
    }
};
const virtualMessageFromEvents = (msg, events) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    // ibc send tx indicated by events
    const ibcSendEventData = (_a = events[0]) === null || _a === void 0 ? void 0 : _a.find((event) => event.type === 'send_packet');
    // ibc receive tx indicated by events
    const ibcRecvEventData = (_b = events[1]) === null || _b === void 0 ? void 0 : _b.find((event) => event.type === 'recv_packet');
    // get rewards tx indicted by events
    const rewardEventData = (_c = events[0]) === null || _c === void 0 ? void 0 : _c.find((event) => event.type === 'withdraw_rewards');
    if (ibcSendEventData) {
        const parsedPacketData = JSON.parse((_e = (_d = ibcSendEventData === null || ibcSendEventData === void 0 ? void 0 : ibcSendEventData.attributes.find((attribute) => attribute.key === 'packet_data')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '{}');
        return {
            type: 'ibc_send',
            value: { amount: parsedPacketData.amount, denom: parsedPacketData.amount },
            from: parsedPacketData.sender,
            to: parsedPacketData.receiver,
            origin: parsedPacketData.sender
        };
    }
    else if (ibcRecvEventData) {
        const parsedPacketData = JSON.parse((_g = (_f = ibcRecvEventData === null || ibcRecvEventData === void 0 ? void 0 : ibcRecvEventData.attributes.find((attribute) => attribute.key === 'packet_data')) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : '{}');
        return {
            type: 'ibc_receive',
            value: { amount: parsedPacketData.amount, denom: parsedPacketData.amount },
            from: parsedPacketData.sender,
            to: parsedPacketData.receiver,
            origin: parsedPacketData.sender
        };
    }
    else if (rewardEventData) {
        const valueUnparsed = (_j = (_h = rewardEventData === null || rewardEventData === void 0 ? void 0 : rewardEventData.attributes) === null || _h === void 0 ? void 0 : _h.find((attribute) => attribute.key === 'amount')) === null || _j === void 0 ? void 0 : _j.value;
        const valueParsed = valueUnparsed === null || valueUnparsed === void 0 ? void 0 : valueUnparsed.slice(0, valueUnparsed.length - 'uatom'.length);
        return {
            type: 'withdraw_delegator_reward',
            value: { amount: valueParsed !== null && valueParsed !== void 0 ? valueParsed : '', denom: 'uatom' },
            from: msg.from,
            to: msg.to,
            origin: msg.origin
        };
    }
    // no virtual message handled, but also no transaction message
    if (!msg) {
        logger.warn(`no transaction message found and unable to create virtual message from events: ${events}`);
    }
    return msg;
};
const valuesFromMsgEvents = (msg, events, assetId) => {
    var _a, _b, _c, _d;
    const virtualMsg = virtualMessageFromEvents(msg, events);
    const data = metaData(virtualMsg, assetId);
    const from = (_a = virtualMsg === null || virtualMsg === void 0 ? void 0 : virtualMsg.from) !== null && _a !== void 0 ? _a : '';
    const to = (_b = virtualMsg === null || virtualMsg === void 0 ? void 0 : virtualMsg.to) !== null && _b !== void 0 ? _b : '';
    const origin = (_c = virtualMsg === null || virtualMsg === void 0 ? void 0 : virtualMsg.origin) !== null && _c !== void 0 ? _c : '';
    const value = new bignumber_js_1.default(((_d = virtualMsg === null || virtualMsg === void 0 ? void 0 : virtualMsg.value) === null || _d === void 0 ? void 0 : _d.amount) || (data === null || data === void 0 ? void 0 : data.value) || 0);
    return { from, to, value, data, origin };
};
exports.valuesFromMsgEvents = valuesFromMsgEvents;
